/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.skills.SkillReferenceDocLoadMode
*/
export var SkillReferenceDocLoadMode;
(function (SkillReferenceDocLoadMode) {
    SkillReferenceDocLoadMode["INLINE"] = "INLINE";
    SkillReferenceDocLoadMode["ON_DEMAND"] = "ON_DEMAND";
})(SkillReferenceDocLoadMode || (SkillReferenceDocLoadMode = {}));
//# sourceMappingURL=SkillReferenceDocLoadMode.js.map